import React from 'react';
import './UnitCard.css';
import mockImg from '../assets/images/mock_unit_img.png';

const UnitCard = ({ image, images, name, label, description, onClick, isClickable = true }) => {
  // Get the first image from images array or use the single image prop
  const displayImage = images && images.length > 0
    ? images[0]
    : image || mockImg;

  // Use label if available, otherwise fall back to name
  const displayName = label || name;

  return (
    <div
      className={`unit-card ${isClickable ? 'unit-card-clickable' : 'unit-card-disabled'}`}
      onClick={isClickable ? onClick : undefined}
      style={!isClickable ? { cursor: 'not-allowed', opacity: 0.6 } : {}}
    >
      <img
        src={displayImage}
        alt={displayName}
        className="unit-card-img"
      />
      <div className="unit-card-content">
        <h3 className="unit-card-title">{displayName}</h3>
        <p className="unit-card-desc">{description}</p>
        {!isClickable && (
          <p className="unit-card-permission-notice" style={{ fontSize: '0.8em', color: '#999', marginTop: '8px' }}>
            Requires permission to view
          </p>
        )}
      </div>
    </div>
  );
};

export default UnitCard; 